/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramTransactionsControllerGetRatesQueryResponse } from '../types/TelegramTransactionsControllerGetRates.ts';

function getTelegramTransactionsGetRatesUrl() {
  const res = { method: 'GET', url: `/api/telegram/transactions/rates` as const };
  return res;
}

/**
 * {@link /api/telegram/transactions/rates}
 */
export async function telegramTransactionsGetRates(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramTransactionsControllerGetRatesQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramTransactionsGetRatesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
